import React, { Component } from "react";
import { Accessor, ColorX, ZTime } from "../../../STATIC";
import PropsType from "prop-types";
import { HStack, Spacer, VStack, XText } from "../../../_X";
import styles from "./_style/clockizo";
import CyclePicker from "./_gears/CyclePicker";
import _ from "lodash";
import OperBar from "../../Libs/OperBar/OperBar";
import QFButton from "IZOX/BLOCKS/Libs/QForm/QFButton";

/**
 * @augments {Component<Props, State>}
 */
class Clockizo extends Component {

  static propTypes = {
    size: PropsType.oneOfType([PropsType.number, PropsType.string]), 

    valTime: PropsType.string,

    minTime: PropsType.string,
    maxTime: PropsType.string,
    minRange: PropsType.number,

    directConfirm: PropsType.bool,

    onConfirm: PropsType.func,
    onCancel: PropsType.func,

    enableMinute: PropsType.bool,
    enableSecond: PropsType.bool,
    onlyTime: PropsType.bool,

    range: PropsType.bool

  };

  static defaultProps = {
    size: 284, 

    valDate: null,
    
    minTime: "00:00",
    maxTime: "23:59",
    minRange: 0,

    directConfirm: false,

    onConfirm: () => {},
    onCancel: () => {},

    enableMinute: false,
    enableSecond: false,
    onlyTime: false,

    range: false
  };

  constructor(props){
    super();
    let {enableMinute, enableSecond, valDate, onlyTime} = props;
    if(valDate) {
      let mo = ZTime.Moment(valDate, onlyTime ? "HH:mm" : undefined);
      this.state = {
        mode: "hour",
        selectedHour: mo.hour(),
        selectedMinute: (enableMinute ? mo.minute() : 0),
        selectedSecond: (enableSecond ? mo.second() : 0)
      };
    }else{
      this.state = {
        mode: "hour",
        selectedHour: 0,
        selectedMinute: 0,
        selectedSecond: 0
      };
    }
    
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(Clockizo.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  shouldComponentUpdate(nextProps, nextState){
    let propIdentical = Accessor.IsIdentical(nextProps, this.props, Object.keys(Clockizo.defaultProps));
    let stateIdentical = Accessor.IsIdentical(nextState, this.state, null);
    if(propIdentical && stateIdentical){
      return false;
    }
    return true;
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  };

  _onConfirm = () => {
    let {onConfirm} = this.props;
    let {selectedHour, selectedMinute, selectedSecond} = this.state;
    onConfirm?.(selectedHour, selectedMinute, selectedSecond);
  };

  _onCancel = () => {
    let {onCancel, addOns} = this.props;
    onCancel?.(addOns);
  };

  _setHour = (number, dragging) => {
    let {enableMinute, directConfirm} = this.props;
    this.setState({
      selectedHour: number
    }, () => {
      if(dragging) return;
      if(enableMinute){
        this._setMode("minute");
      }else{
        if(directConfirm){
          this._onConfirm();
        }
      }
    });
  };

  _setMinute = (number, dragging) => {
    let {enableSecond, directConfirm} = this.state;
    this.setState({
      selectedMinute: number
    }, () => {
      if(dragging) return;
      if(enableSecond){
        this._setMode("second");
      }else{
        if(directConfirm){
          this._onConfirm();
        }
      }
    });
  };

  _setSecond = (number, dragging) => {
    let {directConfirm} = this.state;
    this.setState({
      selectedSecond: number
    }, () => {
      if(dragging) return;
      if(directConfirm){
        this._onConfirm();
      }
    });
  };

  _setMode = (mode) => {
    this.setState({
      mode: mode
    });
  };

  renderCore(){
    let {mode} = this.state;
    switch(mode){
      default: case "hour": return this.renderHourPicker();
      case "minute": return this.renderMinutePicker();
      case "second": return this.renderSecondPicker();
    }
  }

  renderHourPicker(){
    let {size} = this.props;
    let {selectedHour} = this.state;
    return (
      <CyclePicker
        size={size}
        selected={selectedHour !== undefined ? String(selectedHour) : undefined}
        selectOptions={_.range(1, 13)}
        selectInnerOptions={[..._.range(13, 24), 0]}
        angleOffsetInterval={1}
        onSelect={this._setHour}
        />
    );   
  }

  renderMinutePicker(){
    let {size} = this.props;
    let {selectedMinute} = this.state;
    return (
      <CyclePicker
        size={size}
        selected={selectedMinute !== undefined ? String(selectedMinute) : undefined}
        selectOptions={_.range(0, 60, 5)}
        angleOffsetInterval={0}
        onSelect={this._setMinute}
        />
    );   
  }

  renderSecondPicker(){
    let {size} = this.props;
    let {selectedSecond} = this.state;
    return (
      <CyclePicker
        size={size}
        selected={selectedSecond !== undefined ? String(selectedSecond) : undefined}
        selectOptions={_.range(0, 60, 5)}
        angleOffsetInterval={0}
        onSelect={this._setSecond}
        />
    );   
  }

  renderModeBtn(caption, _mode){
    let {mode} = this.state;
    return QFButton.Bullet(() => this._setMode(_mode), 
      caption, null, {
        bgColor: ColorX.CSS("cmBlue"), 
        inverted: mode !== _mode,
        fitWidthToContent: true,
        minWidth: 0
      });
  }

  renderTitle(){
    let {enableMinute, enableSecond} = this.props;
    let {selectedHour, selectedMinute, selectedSecond} = this.state;
    let str = String(selectedHour).padStart(2, "0");
    str += enableMinute ? (":" + String(selectedMinute).padStart(2, "0")) : ":00";
    str += enableSecond ? (":" + String(selectedSecond).padStart(2, "0")) : "";

    return (
      <HStack p={10} spacing={5}>
        <XText style={{marginHorizontal: 20, fontFamily: "sans-serif"}}>
          {str}
        </XText>
        <Spacer/>
        {this.renderModeBtn("H", "hour")}
        {enableMinute && this.renderModeBtn("M", "minute")}
        {enableSecond && this.renderModeBtn("S", "second")}
      </HStack>
    );
  }

  render(){
    let {directConfirm, size} = this.props;
    return (
      <VStack width={size} style={styles.mainContainer}>
        {this.renderTitle()}
        {this.renderCore()}
        {!directConfirm &&
          <OperBar onConfirm={this._onConfirm} 
            onCancel={this._onCancel}/>
        }
      </VStack>
    );
  }
}

export default Clockizo;
